// Full-document render of the lookup-orders-by-email confirmation page:
// PageSkeleton wrapping the toppers customer-service side-nav account shell --
// the "My Account" content title and the static confirmation copy. The heading
// + paragraphs arrive as props (server-side gettext), matching
// lookup-orders-by-email-confirmation.html.
import React from "react";

import { templates } from "@reactivated";

import { AccountShell } from "../components/AccountShell";
import { PageSkeleton } from "../components/PageSkeleton";

export const Template = (
    props: templates.LookupOrdersByEmailConfirmationDocumentTemplate,
): React.JSX.Element => (
    <PageSkeleton pageChrome={props.page_chrome}>
        <AccountShell
            hasNav={props.has_nav}
            sideNav={props.side_nav}
            title={props.content_title}
            phoneDisplay={props.phone_display}
            phoneHref={props.phone_href}
        >
            <h2>{props.heading}</h2>
            <div>
                {props.paragraphs.map((paragraph, i) => (
                    <p key={i}>{paragraph}</p>
                ))}
            </div>
        </AccountShell>
    </PageSkeleton>
);
